import { Icon, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormStatusEnum } from "../../../_common/enum/forms/formStatus.enum";
import { IFormTemplateSectionList } from "../../../_common/models/formTemplateSection";
import { PrimaryButton } from "../../../_components/button/primary.button";
import { toastr } from "../../../_components/toastr/toastr";
import { formTemplateSectionService } from "../../../_services/formTemplateSection.service";

export function FormTemplateSectionList(params: { formStatus?: FormStatusEnum }) {

    const [data, setData] = useState<Array<IFormTemplateSectionList>>([]);
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);
    const [selectedSectionId, setSelectedSectionId] = useState(0);

    const { formTemplateId } = useParams<{ formTemplateId: string }>();

    let navigate = useNavigate();

    useEffect(() => {
        if (formTemplateId) fetchData();
        else setData([]);
    }, [formTemplateId]);

    function fetchData() {
        setLoading(true);
        return formTemplateSectionService
            .getAll(+(formTemplateId || 0))
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function disable(id: number) {
        setSaving(true);
        return formTemplateSectionService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    fetchData();
                }
            )
            .finally(() => setSaving(false));
    }

    return (
        <>

            {(data && data.length > 0) && data.map(item =>

                <List dense={true}>
                    <ListItem button disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} onClick={() => setSelectedSectionId(item.id)}>
                        <ListItemText
                            primary={item.name}
                            secondary={"Section Order: " + item.sectionOrder}
                        />
                        <ListItemSecondaryAction>
                            <IconButton
                                // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                edge="end" aria-label="view" onClick={() => { navigate("/FormTemplateSections/" + item.id) }}>
                                <Icon>visibility</Icon>
                            </IconButton>
                            <IconButton
                                // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                edge="end" aria-label="edit" onClick={() => { navigate("EditSection/" + item.id) }}>
                                <Icon>edit</Icon>
                            </IconButton>

                            <IconButton
                                // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                edge="end" aria-label="delete" onClick={() => disable(item.id)}>
                                <Icon>delete</Icon>
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                </List>

            )}

            {(data && data.length < 1) &&
                <p>No Template Sections</p>
            }

            <PrimaryButton
                type="button"
                variant="primary"
                // disabled={isLoading || (params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess)}
                onClick={() => { navigate(`CreateSection/`) }}>
                <Icon>add</Icon> {<>Create Section</>}
            </PrimaryButton>
        </>

    );
}